import React, { Suspense } from "react";
import { useRoutes } from "react-router-dom";
import { ClipLoader } from "react-spinners";

//home
//const Home = React.lazy(() => import('../pages/Home'));
//const Home = React.lazy(() => import('../pages/landings/Index2'));

const Home = React.lazy(() =>
    new Promise<{ default: React.ComponentType<any> }>(resolve => {
        setTimeout(() => import('../pages/landings/Index2').then(module => resolve(module)), 50);
    })
);

//landings
//const Index1 = React.lazy(() => import('../pages/landings/Index1'));
//const index2 = React.lazy(() => import('../pages/landings/Index2'));
//const index3 = React.lazy(() => import('../pages/landings/Index3'));
//const index4 = React.lazy(() => import('../pages/landings/Index4'));
//const index5 = React.lazy(() => import('../pages/landings/Index5'));
//const index6 = React.lazy(() => import('../pages/landings/Index6'));


//auth
// const Login = React.lazy(() => import('../pages/auth/Login'))
// const SignUp = React.lazy(() => import('../pages/auth/Signin'))

const loading = () => (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
        <ClipLoader color="#0d6efd" size={40} />
    </div>
);

type LoadingComponentProps = {
    component: React.LazyExoticComponent<React.ComponentType<any>>;
};

const LoadComponent = ({ component: Component }: LoadingComponentProps) => {
    return (
        <Suspense fallback={loading()}>
            <Component />
        </Suspense>
    )
};

const AllRoutes = () => {
    return useRoutes([
        {
            path: '/',
            element: <LoadComponent component={Home} />,
        }
    ])
}

export default AllRoutes;
